<template>
  <div class="">
    <iframe style="height: 92vh;width: 100%;" :src="invoiceUrl" frameborder="0" v-if="invoiceUrl"></iframe>
    <noData v-else></noData>
  </div>
</template>

<script>
let statusMap = {
  '0': '未申请',
  '1': '已申请',
  '2': '已开票',
}
import noData from '@/components/commons/noData';
import { number_format } from '@/api/filter';
import { pageTool } from '@/api/mixins';
export default {
  mixins: [pageTool],
  components: {
    noData
  },
  props:['invoiceUrl'],
  data() {
    return {
      loading: false,
      columns: [
        {
          title: "申请日期",
          align: "center",
          minWidth: 160,
          key: 'applyDate',
        },
        {
          title: '开票业务',
          key: 'bussiness',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '发票金额',
          key: 'amount',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.amount, 2)}</span>
          }
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return <span> {statusMap[params.row.status]}</span>
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '120',
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    this.tableData = [];
    this.initListAjax('/buz/invoiceRecord/read/list');
    if(!this.$units.pointAction('order_50_10')) {
      this.columns.splice(this.columns.length-1 ,1);
    }
  },
  methods: {
    getDetail() {
      this.$http({
        url: `/buz/invoiceRecord/waitApplyList`,
        type: "GET",
        data: {
          policyNo: this.$route.query.policyNo
        },
        apiPermissionCode:'order_50_9'
      }).then((res) => {
        if (res.data.waitInvoiceRecordVos.length == 0) {
          this.$notice.error("没有待开票的记录");
        } else {
          this.$router.push({
            path: '/orderManage/group/invoiceList',
            query: this.$route.query
          })
        }
      })
    },
    policyDetail(row) {
      row.invoiceUrl && window.open(row.invoiceUrl, "_blank");
    },
    // 转化参数
    setListParams(params) {
      params.policyNo = this.$route.query.policyNo;
    },
  }
};
</script>
<style lang="scss" scoped>
.search-box {
  padding-right: 250px;
}

.title {
  margin-top: 10px;
  margin-bottom: 10px;
}

.btn-wrap {
  margin-bottom: 10px;

  span {
    margin-left: 10px;
  }
}

/deep/ .top-line .ivu-table-tbody {
  border-top: 1px solid #E9E9E9;
}

.tools-box {
  display: flex;
  justify-content: flex-end;

}
</style>
